'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiAuthentication = function ApiAuthentication(Restangular, ApiBaseResponseService) {
    _classCallCheck(this, ApiAuthentication);

    return {
        validatePasswordToken: function validatePasswordToken(token) {
            return Restangular.all('authentication/password/reset').get('validateToken', { 'token': token }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        resetPassword: function resetPassword(password, token) {
            return Restangular.all('authentication/password/reset').post({ 'token': token, 'password': password }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        activateUser: function activateUser(token) {
            return Restangular.all('authentication/activate').post(null, { 'token': token }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        loginUser: function loginUser(username, password) {
            return Restangular.all('authentication/login').post({ 'username': username, 'password': password }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onLoginError);
        },
        initiatePasswordReset: function initiatePasswordReset(email) {
            return Restangular.all('/authentication/password/reset/init').post(null, { 'email': email }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        }
    };
};

ApiAuthentication.inject = ['Restangular', 'ApiBaseResponseService'];

exports.default = ApiAuthentication;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiAuthentication.js
 **/